import { useSavedInRef } from '@coop/hooks';
import { useEffect } from 'react';

/**
 *  @deprecated Extraction on texts will be moved into parent component instead of syncing it with parent.
 * */
export const useSyncA11yTextWithParent = (
    a11yText?: string,
    setA11yLabel?: (label: string) => void,
) => {
    const savedSetter = useSavedInRef(setA11yLabel);

    useEffect(() => {
        if (a11yText && savedSetter.current) {
            savedSetter.current(a11yText);
        }
    }, [a11yText, savedSetter]);
};
